export default __webpack_public_path__ + "static/media/photo-1546456073-6712f79251bb.a031da78.jpeg";